function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(10.000000, -8.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(199.866957, 210.635678) rotate(-30.000000) translate(-199.866957, -210.635678) translate(39.866957, 69.635678)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "76.2756822 0 237.809906 0 255.836314 30.6115604 144.084707 30.6115604 144.084707 18.4072598 112.736975 18.4072598 112.736975 5.90311568 72.7250973 5.90311568"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "52.0000577 42 262.809906 42 280.836314 72.6115604 169.084707 72.6115604 169.084707 60.4072598 84.0613192 60.4072598 84.0613192 47.9031157 48.6220687 47.9031157"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "27.7723931 84 286.809906 84 304.836314 114.61156 200.555958 114.61156 200.555958 102.40726 59.1120723 102.40726 59.1120723 89.9031157 24.2218082 89.9031157"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "3.55058493 126 310.957535 126 319.07073 140.488017 309.999711 156.61156 195.107135 156.61156 195.107135 144.40726 43.854434 144.40726 43.854434 131.903116 -2.84217094e-14 131.903116"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "9.69127366 167 303.871627 167 286.131521 197.61156 171.102987 197.61156 171.102987 185.40726 42.2531737 185.40726 42.2531737 172.903116 13.3592664 172.903116"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "34.0050916 209 279.871627 209 262.131521 239.61156 147.102987 239.61156 147.102987 227.40726 69.3259998 227.40726 69.3259998 214.903116 37.6730844 214.903116"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "58.1026456 251.364322 254.999578 251.364322 237.259472 281.975883 117.257385 281.975883 117.257385 269.771582 89.8614223 269.771582 89.8614223 257.267438 61.7706384 257.267438"
}))));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "419px",
    height: "405px",
    viewBox: "0 0 419 405",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17ea95f6.svg";
export { ForwardRef as ReactComponent };